import React, { useEffect } from 'react';
import './index.scss';
import { NewsCard } from './NewsCard';
import styled from 'styled-components';
import { useUserContext } from '../../components/UserData';
import { Link, useHistory } from 'react-router-dom';

const Root = styled.div`
  padding-bottom: 80px;
  width: 1200px;
  margin: auto;
  &.news-list {
    margin-top: 80px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: #f4f4f4;
    .news-card {
      margin-bottom: 20px;
      width: 100%;
    }
  }
  &.article {
    margin-top: 80px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: #f4f4f4;
    //margin-top: 80px;
  }
`;

const Trend = () => {
  const { state, update } = useUserContext((t) => [t.frameUrl, t.articles]);
  const list = state.articles;
  const history = useHistory();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <Root className='news-list'>
      {list.map((item, index) => {
        const { img, title, desc, time, url, fromConfig } = item;
        return (
          <NewsCard
            img={img}
            title={title}
            desc={desc}
            time={time}
            key={index}
            onClick={() => {
              if (fromConfig) {
                window.open(url, '_blank');
              } else {
                update((t) => (t.frameUrl = url));
                if (url.includes('https://page.meituan.net')) {
                  const link = encodeURIComponent(url);
                  history.push({ pathname: '/trend/detail', search: 'pageLink=' + link });
                }
              }
            }}
          />
        );
      })}
    </Root>
  );
};

export default Trend;
